import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import tw from 'twin.macro';

import { useGetStatusQuery } from '@/app/api/application';
import { getApplyData, getCardType } from '@/app/store/slices/app';
import { clearCustomError, getCustomErrors } from '@/app/store/slices/error';
import BigExclamationIcon from '@/assets/images/icons/BigExclamationIcon';
import XIcon from '@/assets/images/icons/XIcon';
import { BodyText, Button, StepContentWrapper } from '@/components';
import useCheckStatus from '@/helper/hooks/useCheckStatus';
import useCheckStatusPrepaid from '@/helper/hooks/useCheckStatusPrepaid';
import Authmodal from '@/views/auth-modal';

const ErrorPage = () => {
  const dispatch = useDispatch();
  const customError = useSelector(getCustomErrors);
  const card_type = useSelector(getCardType);
  const applyData = useSelector(getApplyData);
  const navigate = useNavigate();
  const { data: statusData } = useGetStatusQuery(null, {
    skip: card_type === 'prepaid-card' || !applyData.mobile_phone
  });

  const [checkStatus] = useCheckStatus();
  const [checkStatusPrepaid] = useCheckStatusPrepaid();
  const handleBackHome = () => {
    navigate('/');
    dispatch(clearCustomError());
  };

  const handleGoResidentSite = () => {
    window.open('https://bankffin.kz/ru/card-issuance/deposit-card', '_blank');
  };

  const handleRetry = () => {
    checkStatus();
    dispatch(clearCustomError());
  };
  const [authOpen, setAuthOpen] = useState(false);

  const renderButton = customError => {
    switch (String(customError?.code).toLowerCase()) {
      case 'resident':
        return (
          <Button variant='secondary' onClick={handleGoResidentSite}>
            {statusData?.data?.card_product === 'INVEST' ? 'Открыть Invest card' : 'Открыть Deposit card'}
          </Button>
        );
      case 'video_call_error':
        return (
          <Button variant='secondary' onClick={handleRetry}>
            Повторить
          </Button>
        );
      case 'brokerage_account_not_found':
        return (
          <a href='https://ffin.kz/' target='_blank' rel='noreferrer'>
            <Button variant='secondary'>Подробнее</Button>
          </a>
        );
      case 'pp_rejected':
        return (
          <Button
            variant='secondary'
            onClick={() => {
              navigate('/prepaid-card-info');
              dispatch(clearCustomError());
              //  window.open(`${import.meta.env.NR_HOMEPAGE}/prepaid-card/apply`, '_self');
            }}
          >
            На страницу карты
          </Button>
        );
      case 'error':
        if (card_type === 'prepaid-card') {
          return (
            <Button
              variant='secondary'
              onClick={() => {
                navigate('/prepaid-card/apply');
                dispatch(clearCustomError());
              }}
            >
              Повторить попытку
            </Button>
          );
        } else {
          return (
            <Button variant='secondary' onClick={handleBackHome}>
              Вернуться на главный экран
            </Button>
          );
        }
      default:
        return (
          <Button variant='secondary' onClick={handleBackHome}>
            Вернуться на главный экран
          </Button>
        );
    }
  };

  return (
    <StepContentWrapper twStyles={tw`text-center max-w-content mx-auto`}>
      <div tw='max-w-[416px] mx-auto flex flex-col gap-5 mb-[45px]'>
        {card_type !== 'prepaid-card' ? (
          <div tw='w-[144px] h-[144px] flex items-center justify-center rounded-full mx-auto bg-yellow-alpha20 mt-[48px]'>
            <BigExclamationIcon />
          </div>
        ) : (
          <div tw='w-[144px] h-[144px] flex items-center justify-center rounded-full mx-auto bg-red-alpha20 mt-[48px]'>
            <XIcon />
          </div>
        )}
        <BodyText
          text={
            String(customError?.code).toLowerCase() === 'invalid_short_link' ? (
              <span>
                Срок действия вашей ссылки истек, продолжите процесс нажав на кнопку &nbsp;
                <button
                  onClick={() => {
                    setAuthOpen(true);
                  }}
                  tw='text-green underline'
                >
                  Войти
                </button>
                .
              </span>
            ) : String(customError.code).toLowerCase() === 'brokerage_account_not_found' ? (
              <span>
                У Вас нет брокерского счета <br />
                Для выпуска карты нужен брокерский счет в Freedom Finance Global PLC. <br />
                Вы можете открыть счет по кнопке
              </span>
            ) : customError?.description ? (
              customError?.description
            ) : (
              'По техническим причинам сервис временно недоступен. Пожалуйста, попробуйте позднее'
            )
          }
          twStyle={tw`text-secondary text-center`}
        />
        {renderButton(customError)}
      </div>
      <Authmodal authOpen={authOpen} setAuthOpen={setAuthOpen} twStyle={tw`text-left`} />
    </StepContentWrapper>
  );
};

export default ErrorPage;
